import { AbstractControl } from '@angular/forms';

export function animateTyping(
  target: AbstractControl | ((val: string) => void),
  fullText: string,
  delayMs = 80
): () => void {
  let index = 0;
  const words = fullText.split(' ');
  let currentText = '';

  const intervalId = setInterval(() => {
    if (index >= words.length) {
      clearInterval(intervalId);
      return;
    }

    currentText += (index === 0 ? '' : ' ') + words[index];

    if (typeof target === 'function') {
      target(currentText); // For [(ngModel)]
    } else {
      target.setValue(currentText); // For Reactive Form
    }

    index++;
  }, delayMs);

  return () => clearInterval(intervalId); // cancellation function
}
